import React, { useMemo } from 'react'
import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { Type } from '@/components/common'
import useSiteAssets from '@/services/hooks/useSiteAssets'
import { scrollUtil } from '@/utils'

export const MyInvestmentsNav: React.FC = () => {
  const { canExpressInterest } = useSiteAssets()

  const tabs = useMemo(
    () => [
      {
        name: 'Investments',
        enabled: true,
      },
      {
        name: 'Expressed Interest',
        enabled: canExpressInterest,
      },
    ],
    [canExpressInterest]
  )

  return (
    <Tab.List
      className={classNames(
        'hide-scrollbar flex gap-8 overflow-auto whitespace-nowrap px-4 md:px-0',
        {
          'md:justify-around': tabs.length >= 3,
          'md:gap-12': tabs.length < 3,
        }
      )}
    >
      {tabs
        .filter((t) => t.enabled)
        .map(({ name }) => (
          <Tab
            name={name}
            key={name}
            className={({ selected }: { selected: boolean }) =>
              classNames(
                'border-b-[3px] py-[10.5px] focus:outline-none active:opacity-75',
                {
                  'border-oxide-3 font-semibold': selected,
                  'border-transparent text-gray': !selected,
                }
              )
            }
            onClick={() => {
              scrollUtil.scrollNamedElementIntoView(name, {
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest',
              })
            }}
          >
            <Type as="span" variant="caption-md">
              {name}
            </Type>
          </Tab>
        ))}
    </Tab.List>
  )
}

export default MyInvestmentsNav
